/**
 * Swiper 11.0.3
 * @url : https://swiperjs.com/api/
 */
// import Swiper JS
// core version + navigation, pagination, freemode & keyboard modules:
import Swiper from 'swiper'
import { FreeMode, Keyboard, Navigation, Autoplay } from 'swiper/modules'

// List slider (for most sliders):
// - Opinions
// - Members
// - Properties
const swiperLists = Array.from(document.getElementsByClassName('js-swiper-list'))
if (swiperLists.length) {
  for (const swiper of swiperLists) {
    // Swiper instance
    const swiperInstance = new Swiper(swiper, {
      modules: [Navigation, FreeMode, Keyboard],
      slidesPerView: 'auto',
      grabCursor: true,
      freeMode: true,
      speed: 700,
      navigation: {
        nextEl: swiper.querySelector('.swiper-button-next'),
        prevEl: swiper.querySelector('.swiper-button-prev'),
      },
      keyboard: true,
      init: false,
    })

    // Init only if there is 2 or more slides
    const nbSlides = Array.from(swiper.getElementsByClassName('swiper-slide'))

    if (nbSlides.length > 1)
      swiperInstance.init()
  }
}

// Members slider
const swiperListAuto = Array.from(document.getElementsByClassName('js-swiper-list-auto'))
if (swiperListAuto.length) {
  for (const swiper of swiperListAuto) {
    // Swiper instance
    const swiperInstance = new Swiper(swiper, {
      modules: [FreeMode, Keyboard, Autoplay],
      autoplay: {
        delay: 0,
        pauseOnMouseEnter: true,
      },
      loop: true,
      slidesPerView: 'auto',
      grabCursor: true,
      freeMode: true,
      speed: 4000,
      keyboard: true,
      init: false,
    })

    // Init only if there is 2 or more slides
    const nbSlides = Array.from(swiper.getElementsByClassName('swiper-slide'))

    if (nbSlides.length > 1)
      swiperInstance.init()
  }
}
